__turbopack_context__.v({
  "fade-in": "Pagination-module-scss-module__1pE-0G__fade-in",
  "link": "Pagination-module-scss-module__1pE-0G__link",
  "linkActive": "Pagination-module-scss-module__1pE-0G__linkActive",
  "linkDisabled": "Pagination-module-scss-module__1pE-0G__linkDisabled",
  "linkEllipsis": "Pagination-module-scss-module__1pE-0G__linkEllipsis",
  "linkNav": "Pagination-module-scss-module__1pE-0G__linkNav" + " " + "Pagination-module-scss-module__1pE-0G__link",
  "list": "Pagination-module-scss-module__1pE-0G__list",
  "navCenter": "Pagination-module-scss-module__1pE-0G__navCenter",
  "no-transform": "Pagination-module-scss-module__1pE-0G__no-transform",
  "rotate": "Pagination-module-scss-module__1pE-0G__rotate",
});
